export var MAX_CONTENT_WIDTH = '1524px';
export var MAX_CONTENT_SCREEN_WIDTH = "calc(".concat(MAX_CONTENT_WIDTH, " + 48px + 48px)");
